// Built-ins
import React from "react";
import { Route, Redirect } from "react-router-dom";

// Component to protect a route. checks if user is logged in when accessing a protected route
// If not logged in, redirects to login page
const PrivateRoute = ({
  component: Component,
  render,
  isLoggedIn,
  adminOnly = false,
  ...rest
}) => {
  const allowed = isLoggedIn === true && (!adminOnly || localStorage.getItem("role") === "A");
  return (
    <Route
      {...rest}
      render={(props) =>
        allowed ? (
          render ? (
            render(props)
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect to={{ pathname: isLoggedIn ? "/dashboard" : "/login" }} />
        )
      }
    />
  );
};

export default PrivateRoute;
